/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Signal kind
 */
export const EventLogEntryKind = {
  Log: "log",
  Span: "span",
} as const;
/**
 * Signal kind
 */
export type EventLogEntryKind = ClosedEnum<typeof EventLogEntryKind>;

/**
 * A single ingested OpenTelemetry signal (log record or span) in the event feed
 */
export type EventLogEntry = {
  /**
   * Signal attributes as a JSON object
   */
  attributes: any;
  /**
   * Log body truncated to 200 characters; empty for spans
   */
  bodyPreview: string;
  /**
   * Signal kind
   */
  kind: EventLogEntryKind;
  /**
   * Event name for logs, span name for spans
   */
  name: string;
  /**
   * Project the event was recorded under
   */
  projectId: string;
  /**
   * Resource attributes as a JSON object
   */
  resourceAttributes: any;
  /**
   * Canonicalized source derived from the resource service name
   */
  source: string;
  /**
   * W3C span ID
   */
  spanId: string;
  /**
   * Event time in Unix nanoseconds (string for JS int64 precision)
   */
  timeUnixNano: string;
  /**
   * W3C trace ID
   */
  traceId: string;
};

/** @internal */
export const EventLogEntryKind$inboundSchema: z.ZodMiniEnum<
  typeof EventLogEntryKind
> = z.enum(EventLogEntryKind);

/** @internal */
export const EventLogEntry$inboundSchema: z.ZodMiniType<
  EventLogEntry,
  unknown
> = z.pipe(
  z.object({
    attributes: z.any(),
    body_preview: z.string(),
    kind: EventLogEntryKind$inboundSchema,
    name: z.string(),
    project_id: z.string(),
    resource_attributes: z.any(),
    source: z.string(),
    span_id: z.string(),
    time_unix_nano: z.string(),
    trace_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "body_preview": "bodyPreview",
      "project_id": "projectId",
      "resource_attributes": "resourceAttributes",
      "span_id": "spanId",
      "time_unix_nano": "timeUnixNano",
      "trace_id": "traceId",
    });
  }),
);

export function eventLogEntryFromJSON(
  jsonString: string,
): SafeParseResult<EventLogEntry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EventLogEntry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EventLogEntry' from JSON`,
  );
}
